/** @jsxImportSource @emotion/react */
import React from 'react';
import type { DivProps } from 'typings';
import * as S from './styles';

interface IStubTitleProps extends DivProps {}

function StubTitle(props: IStubTitleProps) {
  const { ...rest } = props;

  return <S.MainBlock {...rest}>Продолжите в мобильном приложении</S.MainBlock>;
}

export default StubTitle;
